import { FilterId } from '../interfaces/filter.interface'
import { IListFilterItem } from '../interfaces/list-filter.interface'

export const defaultFilterItems: IListFilterItem[] = [{
  type: 'common',
  value: 'true',
  field: FilterId.QuickFilters,
  label: $localize`:@@filters.quick-filters-title:Quick Filters`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.CatSubcat,
  label: $localize`:@@filters.category-title:Category`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.MakeModel,
  label: $localize`:@@filters.make-title:Make`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.PriceRange,
  label: $localize`:@@filters.price-range-title:Price Range`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.Meter,
  label: $localize`:@@filters.meter-title:Meter`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.Year,
  label: $localize`:@@filters.model-year-title:Model Year`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.ZipCode,
  label: $localize`:@@filters.zip-code-title:Zip Code`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: FilterId.Location,
  label: $localize`:@@filters.location-title:Location`,
  display: true,
}]

export const defaultCustomFilterItems: IListFilterItem[] = [{
  type: 'custom',
  value: 'true',
  field: FilterId.Option01Date,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option02Date,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option01String,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option02String,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option03String,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option01Numeric,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option02Numeric,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option01Bit,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option02Bit,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option01Financial,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option02Financial,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option03Financial,
  display: false,
}, {
  type: 'custom',
  value: 'true',
  field: FilterId.Option04Financial,
  display: false,
}]

export const defaultQuickFilterItems: IListFilterItem[] = [{
  type: 'common',
  value: 'true',
  field: 'is_featured',
  label: $localize`:@@quick-filters.is_featured:Featured`,
  display: true,
},{
  type: 'common',
  value: 'true',
  field: 'filter_is_low_hours',
  label: $localize`:@@quick-filters.filter_is_low_hours:Low Hours`,
  display: true,
}, {
  type: 'common',
  value: 'true',
  field: 'has_approved_photos',
  label: $localize`:@@quick-filters.has_approved_photos:Listings with Photos`,
  display: true,
}]
